
export default {
    expensesTableList:[],
    taxTableList:[],
    vendors:[]
}
